module.exports = __webpack_public_path__ + "img/add.71494693.svg";